import type { FaqAccordionControllerProps } from '@application/components';
import { FaqAccordionController } from '@application/components';
import { MtFaqPage } from '@presentation/pages';
import type { FC } from 'react';

interface MtFaqPageControllerProps extends Pick<FaqAccordionControllerProps, 'resource'> {}

export const MtFaqPageController: FC<MtFaqPageControllerProps> = (props) => {
  const { resource } = props;
  return (
    <MtFaqPage
      resource={resource}
      accordionComponent={<FaqAccordionController resource={resource} />}
    />
  );
};
